export enum spro_enum_columnType {
	TEXTE = 'text',
	NUMERIQUE = 'numeric',
	MONETAIRE = 'monetaire',
	POURCENTAGE = 'pourcentage',
	BOOLEEN = 'boolean',
	DATE = 'date',
	INFO = 'info',
	TRADUCTION = 'trad',
}



// WEBPACK FOOTER //
// C:/spro/Workspaces/VisualCode/Ecoltex2/src/app/sproLib/spro/enums/spro-columnType.enum.ts